/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_datetime.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Converts an input value to a date value.\nA string will only be successfully converted if it’s respecting the format `yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'`.\nTo convert dates in other formats, use `DATE_PARSE`.',
  examples: [
    'ROW string = ["1953-09-02T00:00:00.000Z", "1964-06-02T00:00:00.000Z", "1964-06-02 00:00:00"]\n| EVAL datetime = TO_DATETIME(string)',
    'ROW int = [0, 1]\n| EVAL dt = TO_DATETIME(int)',
  ],
  note: 'Note that when converting from nanosecond resolution to millisecond resolution with this function, the nanosecond date is truncated, not rounded.',
  params: {
    field: 'Input value. The input can be a single- or multi-valued column or an expression.',
  },
};

export default docs;
